import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperBuyProductPayScanPage } from './shopper-buy-product-pay-scan';

@NgModule({
  declarations: [
    ShopperBuyProductPayScanPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuyProductPayScanPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuyProductPayScanPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product-pay-scan/shopper-buy-product-pay-scan.module.ts